import script from "./currentTime.vue?vue&type=script&setup=true&lang=js"
export * from "./currentTime.vue?vue&type=script&setup=true&lang=js"

import "./currentTime.vue?vue&type=style&index=0&id=f3c264f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3c264f8"]])

export default __exports__